/**
 * Fantasy Console 0 - Selection Toolbar Component
 *
 * Floating toolbar shown when notes are selected.
 * Provides batch operations: transpose, set waveform/effect, delete.
 */

import styles from './SelectionToolbar.module.css'

interface SelectionToolbarProps {
  selectedCount: number
  onTranspose: (semitones: number) => void
  onSetWaveform: (waveform: number) => void
  onSetEffect: (effect: number) => void
  onDelete: () => void
  onClearSelection: () => void
}

export function SelectionToolbar({
  selectedCount,
  onTranspose,
  onSetWaveform,
  onSetEffect,
  onDelete,
  onClearSelection,
}: SelectionToolbarProps) {
  if (selectedCount === 0) return null

  return (
    <div className={styles.container}>
      <span className={styles.count}>{selectedCount} selected</span>
      <div className={styles.group}>
        <span className={styles.groupLabel}>Transpose</span>
        <button
          className={styles.button}
          onClick={() => onTranspose(-12)}
          title='Down octave'
        >
          -12
        </button>
        <button
          className={styles.button}
          onClick={() => onTranspose(-1)}
          title='Down semitone'
        >
          -1
        </button>
        <button
          className={styles.button}
          onClick={() => onTranspose(1)}
          title='Up semitone'
        >
          +1
        </button>
        <button
          className={styles.button}
          onClick={() => onTranspose(12)}
          title='Up octave'
        >
          +12
        </button>
      </div>
      <div className={styles.group}>
        <span className={styles.groupLabel}>Waveform</span>
        <select
          className={styles.select}
          onChange={(e) => onSetWaveform(parseInt(e.target.value))}
          defaultValue=''
        >
          <option value='' disabled>
            Set...
          </option>
          <option value='0'>Sine</option>
          <option value='1'>Triangle</option>
          <option value='2'>Sawtooth</option>
          <option value='3'>Square</option>
          <option value='4'>Pulse 25%</option>
          <option value='5'>Pulse 12%</option>
          <option value='6'>Noise</option>
          <option value='7'>Rounded Saw</option>
        </select>
      </div>
      <div className={styles.group}>
        <span className={styles.groupLabel}>Effect</span>
        <select
          className={styles.select}
          onChange={(e) => onSetEffect(parseInt(e.target.value))}
          defaultValue=''
        >
          <option value='' disabled>
            Set...
          </option>
          <option value='0'>None</option>
          <option value='1'>Slide</option>
          <option value='2'>Vibrato</option>
          <option value='3'>Drop</option>
          <option value='4'>Fade In</option>
          <option value='5'>Fade Out</option>
          <option value='6'>Arp Fast</option>
          <option value='7'>Arp Slow</option>
        </select>
      </div>
      <button
        className={`${styles.button} ${styles.danger}`}
        onClick={onDelete}
        title='Delete selected notes (Del)'
      >
        Delete
      </button>
      <button
        className={styles.button}
        onClick={onClearSelection}
        title='Clear selection (Esc)'
      >
        Deselect
      </button>
    </div>
  )
}
